"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _whiteListProps = _interopRequireDefault(require("./helpers/whiteListProps"));

var _index = _interopRequireDefault(require("./index"));

var createIcon = function createIcon(def, viewBox, displayName) {
  var icon = function icon(props) {
    return /*#__PURE__*/React.createElement(_index.default, (0, _extends2.default)({
      viewBox: viewBox
    }, (0, _whiteListProps.default)(props)), def);
  };

  icon.displayName = displayName;
  return icon;
};

var _default = createIcon;
exports.default = _default;